import { afterNextRender, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loggedGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.jwt_token) {
    if (state.url.startsWith('/viaggi-di-gruppo/join')) {
      afterNextRender(() => {
        sessionStorage.setItem('urlToNavigate', state.url);
      });
    }
    if (state.url.startsWith('/user/notifications')) {
      afterNextRender(() => {
        sessionStorage.setItem('urlToNavigateNotifications', state.url);
      });
    }
    router.navigateByUrl('/login');
    return false;
  }
  return true;
};
